import { forwardRef } from 'react';
import { StyledTags } from './styled';

const Tags = forwardRef((props, ref) => <StyledTags ref={ref} {...props} />);

export default Tags;
